import type { IconSvgObject } from './types';

const SortingAZ02Icon: IconSvgObject = [
  ["path", { d: "M4.5 14H9.5V14.5L4.5 20.5V21H9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 9.5L6.5 3H7.5L10 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 17L17 20L20 17M17 4V19.3912", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SortingAZ02Icon;
